import {
  Button,
  Drawer,
  DrawerSize,
  Menu,
  MenuDivider,
  MenuItem,
} from '@blueprintjs/core';
import classNames from 'classnames';

import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import styles from './Sidemenu.module.scss';

import * as api from 'api';
import { useAppDispatch, useAppSelector } from 'hooks';
import { reloadRole } from 'store/general';
import { Role, View, viewAuthorizedRoles, viewRoutes } from '../../constants';

const viewNames = {
  [View.results]: 'Results',
  [View.grading]: 'Grading',
  [View.registration]: 'Registration',
};

export default function Sidemenu({
  open,
  onClose,
  openAuthModal,
}: {
  open: boolean;
  onClose: () => void;
  openAuthModal: () => void;
}) {
  const { role, email } = useAppSelector((state) => state.general);
  const loggedIn = !!email;
  const dispatch = useAppDispatch();

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    onClose();
  }, [location]);

  const menuItemProps = (view: View) => {
    return {
      className: classNames(
        location.pathname === viewRoutes[view] && styles.activeItem,
        styles.menuItem
      ),
      text: viewNames[view],
      onClick: (
        e:
          | React.MouseEvent<HTMLElement, MouseEvent>
          | React.MouseEvent<HTMLAnchorElement, MouseEvent>
      ) => {
        navigate(viewRoutes[view]);
        e.stopPropagation();
      },
    };
  };

  const views = [View.results, View.grading, View.registration].filter(
    (view) => {
      return viewAuthorizedRoles[view].includes(role as Role);
    }
  );

  return (
    <Drawer
      className={styles.drawer}
      onClose={onClose}
      size={DrawerSize.SMALL}
      isOpen={open}
    >
      <div className={styles.content}>
        <Button
          icon="cross"
          minimal
          className={styles.closeButton}
          onClick={onClose}
        />
        <Menu className={styles.menu}>
          {views.map((view) => (
            <React.Fragment key={view}>
              <MenuDivider />
              <MenuItem {...menuItemProps(view)} />
            </React.Fragment>
          ))}
          <MenuDivider />
        </Menu>

        <Menu className={styles.menu}>
          {loggedIn && <div className={styles.email}>{email}</div>}

          <MenuDivider />
          <MenuItem
            text={loggedIn ? 'Sign out' : 'Sign in'}
            onClick={async () => {
              if (loggedIn) {
                await api.logout();
                await dispatch(reloadRole());

                navigate(viewRoutes[View.results]);
              } else {
                openAuthModal();
              }
            }}
          />

          <MenuDivider />
        </Menu>
      </div>
    </Drawer>
  );
}
